angular.module('shared-components.extended-filters', []);